import React, { useState, useEffect, useMemo } from "react";
import { MapContainer, TileLayer, AttributionControl } from "react-leaflet";
import WeatherMarker from "./WeatherMaker";
import { useSelector } from "react-redux";
import useWindowDimensions from "./useWindowDimensions";
import IsLoading from "./IsLoading";
import HasError from "./HasError";

const WeatherMap = () => {
  const { screenWidth } = useWindowDimensions();

  // Selectors for data and loading/error states
  const weather = useSelector((state) => state.weather);
  const weatherLoading = weather.weatherLoading;
  const weatherData = weather.weatherData.SATA2 || [];
  const weatherError = weather.weatherError;
  const information = useSelector((state) => state.information);
  const informationData = information.informationData;
  const informationLoading = information.informationLoading;
  const informationError = information.informationError;

  // Memoized modified weather data to prevent unnecessary re-renders
  const modifiedWeatherData = useMemo(() => {
    return weatherData.map((station) => {
      const specificStationInformation = informationData.find(
        (specificStation) =>
          specificStation.device === "SATA2" &&
          specificStation.device_id === station.device_id
      );
      return { ...station, ...specificStationInformation };
    });
  }, [weatherData, informationData]);

  // Map settings state
  const [mapZoom, setMapZoom] = useState(5.6);
  const [mapHeight, setMapHeight] = useState("90vh");

  // Memoize map settings calculation
  useEffect(() => {
    setMapZoom(screenWidth < 600 ? 2 : 5.6);
    setMapHeight(screenWidth < 600 ? "70vh" : "90vh");
  }, [screenWidth]);

  if (weatherLoading || informationLoading) {
    return <IsLoading />;
  } else if (weatherError || informationError) {
    return <HasError />;
  } else if (Array.isArray(modifiedWeatherData)) {
    return (
      <div dir="ltr" className="row my-5 mx-md-5">
        <MapContainer
          id="weatherMap"
          center={[32.739, 53.688]}
          zoom={mapZoom}
          zoomSnap={0.1}
          style={{
            width: "90%",
            height: mapHeight,
            margin: "auto",
          }}
          attributionControl={false}
        >
          {modifiedWeatherData.map((station) => (
            <React.Fragment key={station.slug || station.device_id}>
              {station && station.is_test === false && (
                <WeatherMarker type={station.device} data={station} />
              )}
            </React.Fragment>
          ))}

          <TileLayer
            attribution="ایستگاه های آنالایزر لحظه ای اتمسفر "
            url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <AttributionControl position="bottomright" prefix={false} />
        </MapContainer>
      </div>
    );
  }
  return null;
};

export default WeatherMap;
